import React from 'react';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

interface ListLayoutSettingsButtonProps {
  onClick: () => void;
  className?: string;
}

const ListLayoutSettingsButton: React.FC<ListLayoutSettingsButtonProps> = ({
  onClick,
  className = '',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${className}`}
      title="List Settings"
    >
      <Cog6ToothIcon className="h-5 w-5" />
    </button>
  );
};

export default ListLayoutSettingsButton;
